var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoneGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Done",
    clipPath: "url(#clip0_1526_4462)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.9999 16.2001L5.4999 12.7001C5.1133 12.3135 4.4865 12.3135 4.0999 12.7001C3.7133 13.0867 3.7133 13.7135 4.0999 14.1001L8.2928 18.293C8.68332 18.6835 9.31648 18.6835 9.70701 18.293L20.2999 7.7001C20.6865 7.3135 20.6865 6.6867 20.2999 6.3001C19.9133 5.9135 19.2865 5.9135 18.8999 6.3001L8.9999 16.2001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1526_4462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneGreen);
export default __webpack_public_path__ + "static/media/done_green.8f1c2ab693742dcc111c840e0a483c02.svg";
export { ForwardRef as ReactComponent };